import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class CommercialLicenseMappingsService {
  constructor(private http: HttpClient) {}

  public fetchCommercialLicenseMappings(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/commercialLicenseMapping/list`
    return this.http.post(url, params)
  }

  public fetchCommercialLicenseMapping(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/commercialLicenseMapping/${id}`
    return this.http.get(url, {})
  }

  public orderCommercialLicenseMapping(
    id: number,
    direction: string,
  ): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/commercialLicenseMapping/${id}/${direction}`
    return this.http.get(url, {})
  }

  public deleteCommercialLicenseMapping(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/commercialLicenseMapping/${id}`
    return this.http.delete(url)
  }

  public createCommercialLicenseMapping(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/commercialLicenseMapping`
    return this.http.post(url, params)
  }

  public updateCommercialLicenseMapping(
    id: number,
    params: object,
  ): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/commercialLicenseMapping/${id}`
    return this.http.put(url, params)
  }
}
